














import Vue, { PropType } from 'vue'
import GridPageHead from '@/pages/common/grid-parts/GridPageHead.vue'
import HeaderPopup from '@/pages/common/parts/header/header-popup/HeaderPopup.vue'
import { TableField } from '@/pages/dictionary/themes/list/types'
import DownloadButton from '@/pages/common/parts/header/DownloadButton.vue'
import { taskLoader } from '@/pages/users/students/list/model/users-students-filters.model'
import { $permissions } from '@/features/session'

export default Vue.extend({
  name: 'StudentsHeader',
  components: {
    DownloadButton,
    GridPageHead,
    HeaderPopup,
  },
  props: {
    tableColumns: { type: Array as PropType<TableField[]> },
    selectedRows: { type: Array as PropType<number[]> },
  },
  effector: {
    $exportTaskLoading: taskLoader.store.$exportTaskLoading,
    $permissions,
  },
})
